const orderRoutes = [
  {
    path: '/Weapp/User/MyOrder/OrderDetail/GcOrderProductDetail/:orderItem/:order',
    name: 'WeappGcOrderProductDetail',
    component: () => import('@/emktcommon/orders/product/GcOrderProductDetail.vue'),
    meta: { title: '产品详情' }
  },
  {
    path: '/Weapp/User/MyOrder/OrderDetail/GcOrderSmartProductDetail/:orderItem/:order',
    name: 'WeappGcOrderSmartProductDetail',
    component: () => import('@/emktcommon/orders/product/GcOrderSmartProductDetail.vue'),
    meta: { title: '产品详情' }
  },
  {
    path: '/Weapp/User/MyOrder/OrderDetail/Progress/:orderItem/:orderNo',
    name: 'WeappGcProgress',
    component: () => import('@/emktcommon/orders/progress/GcProgressWithActions.vue'),
    meta: { title: '进展详情' }
  },
  {
    path: '/Weapp/User/MyOrder/OrderDetail/Task/:contractNo/:status/:taskModules',
    name: 'WeappGcServiceTaskProgress',
    component: () => import('@/emktcommon/orders/progress/components/GcServiceTaskProgressBase.vue'),
    meta: { title: '实验详情' }
  },
  {
    path: '/Weapp/User/MyOrder/OrderDetail/GcOrderInvoiceDetail/:orderNo',
    name: 'WeappGcOrderInvoiceDetail',
    component: () => import('@/emktcommon/orders/invoice/GcOrderInvoiceDetail.vue'),
    meta: { title: '开票回款金额信息' }
  },
  {
    path: '/Weapp/User/MyOrder/OrderDetail/HistoryProgress/:contractProgressInfo',
    name: 'WeappGcContractHistoryProgress',
    component: () => import('@/emktcommon/orders/progress/components/GcServiceHistoryProgressBase.vue'),
    meta: { title: '历史进展' }
  },
  {
    path: '/Weapp/User/MyOrder/OrderDetail/GcOrderGoodsDetail/:contractNos',
    name: 'WeappGcOrderGoodsDetail',
    component: () => import('@/emktcommon/orders/goods/GcOrderGoodsDetail.vue'),
    meta: { title: '实物信息' }
  }

]

export default orderRoutes



// WEBPACK FOOTER //
// ./src/emktcommon/router/orders.js